var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header" },
    [
      _vm._t("collapseBtn"),
      _c("div", { staticClass: "logo" }, [
        _c("img", {
          staticClass: "logo-icon",
          attrs: {
            src: require("@/assets/img/icon-kpmglogo.svg"),
            width: "100%",
          },
        }),
        _c("span", [_vm._v(_vm._s(_vm.$t("COMMON_PROJECT_NAME")))]),
      ]),
      _c("div", { staticClass: "header-right" }, [
        _c(
          "div",
          { staticClass: "header-user-con" },
          [
            _c(
              "div",
              { staticClass: "btns" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: { placement: "bottom" },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.fullscreen
                                    ? _vm.$t("full_no_screen")
                                    : _vm.$t("full_screen")
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          staticStyle: { display: "flex" },
                          on: { click: _vm.handleFullScreen },
                        },
                        [
                          _vm.fullscreen
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icon-Exit-fullscreen.svg"),
                                  width: "100%",
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icon-fullscreen.svg"),
                                  width: "100%",
                                },
                              }),
                        ]
                      ),
                    ],
                  ],
                  2
                ),
                _c(
                  "el-tooltip",
                  {
                    attrs: { placement: "bottom" },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _vm._v(" " + _vm._s(_vm.$t("i18n_btn")) + " "),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          staticStyle: { display: "flex" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCommand("i18nchange")
                            },
                          },
                        },
                        [
                          this.$i18n.locale === "zh"
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icon-EN.svg"),
                                  width: "100%",
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icon-CN.svg"),
                                  width: "100%",
                                },
                              }),
                        ]
                      ),
                    ],
                  ],
                  2
                ),
                _vm.isKpmgUser && false
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: { placement: "bottom" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(" " + _vm._s(_vm.$t("Contact")) + " "),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          125154920
                        ),
                      },
                      [
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              staticStyle: { display: "flex" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCommand("Contact")
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icon-contactus.svg"),
                                  width: "100%",
                                },
                              }),
                            ]
                          ),
                        ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.isClientUser && false
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: { placement: "bottom" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(" " + _vm._s(_vm.$t("Contact")) + " "),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          125154920
                        ),
                      },
                      [
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              staticStyle: { display: "flex" },
                              on: { click: _vm.toogleSupportVisible },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icon-contactus.svg"),
                                  width: "100%",
                                },
                              }),
                            ]
                          ),
                        ],
                      ],
                      2
                    )
                  : _vm._e(),
                false
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: { placement: "bottom" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("KCC_short_introduction")) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4202844145
                        ),
                      },
                      [
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              staticStyle: { display: "flex" },
                              on: { click: _vm.handleShowKccVideo },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/icon-video.svg"),
                                  width: "100%",
                                },
                              }),
                            ]
                          ),
                        ],
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "el-tooltip",
                  {
                    attrs: { placement: "bottom" },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _vm._v(" " + _vm._s(_vm.$t("FAQ_TITLE")) + " "),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn",
                          staticStyle: { display: "flex" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCommand("faq")
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icon-FAQ.svg"),
                              width: "100%",
                            },
                          }),
                        ]
                      ),
                    ],
                  ],
                  2
                ),
                _vm.isKpmgUser
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: { placement: "bottom" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("KCC_portal_TITLE")) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          299729847
                        ),
                      },
                      [
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              staticStyle: {
                                display: "flex",
                                background: "#cccccc42",
                                "border-radius": "15px",
                                padding: "5px 10px",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCommand("portal")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  position: "relative",
                                  top: "1px",
                                },
                                attrs: {
                                  src: require("@/assets/img/icon-kcc-portal.svg"),
                                  width: "20px",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-left": "4px",
                                    position: "relative",
                                    top: "1px",
                                  },
                                },
                                [_vm._v("KCC Portal")]
                              ),
                            ]
                          ),
                        ],
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("div", {
              staticClass: "user-avatar",
              style: { backgroundImage: `url(${_vm.user.portrait})` },
            }),
            _vm.isKpmgUser
              ? _c("div", { staticClass: "user-name" }, [
                  _c("div", { staticClass: "user-title" }, [
                    _c("p", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.user.userName)),
                    ]),
                    _c("p", { staticClass: "position" }, [
                      _vm._v(_vm._s(_vm.user.title)),
                    ]),
                  ]),
                ])
              : _c(
                  "el-dropdown",
                  {
                    staticClass: "user-name",
                    attrs: { trigger: "click", disabled: _vm.isKpmgUser },
                    on: {
                      "visible-change": _vm.dropVisible,
                      command: _vm.handleCommand,
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "el-dropdown-link",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("div", { staticClass: "user-title" }, [
                          _c("p", { staticClass: "name" }, [
                            _vm._v(_vm._s(_vm.user.userName)),
                          ]),
                          _c("p", { staticClass: "position" }, [
                            _vm._v(_vm._s(_vm.user.title)),
                          ]),
                        ]),
                        _c("i", {
                          class: [
                            "el-icon-arrow-down",
                            _vm.isArrowUp ? "arrow-up" : "",
                          ],
                        }),
                      ]
                    ),
                    _c(
                      "el-dropdown-menu",
                      {
                        staticClass: "dropdown-menu-operate",
                        attrs: { slot: "dropdown" },
                        slot: "dropdown",
                      },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { divided: "", command: "resetPassWord" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("btn_resetPassword")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          { attrs: { divided: "", command: "configTimeout" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("configTimeout")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          { attrs: { divided: "", command: "loginout" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("login_out")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("configTimeoutDialogTitle"),
            visible: _vm.timeoutVisible,
            width: "20%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.timeoutVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "center" },
            [
              _c("el-input-number", {
                attrs: { precision: 1, step: 0.5, max: 8, min: 0.5 },
                model: {
                  value: _vm.outTime,
                  callback: function ($$v) {
                    _vm.outTime = $$v
                  },
                  expression: "outTime",
                },
              }),
              _vm._v(
                "\n            " + _vm._s(_vm.$t("hour")) + "\n            "
              ),
              _c(
                "div",
                {
                  staticClass: "tip",
                  staticStyle: { color: "#fd349c", "text-align": "left" },
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("outTimeTips")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setOutTime } },
                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm.supportVisible
        ? _c("contact-us", {
            attrs: {
              onCancel: _vm.toogleSupportVisible,
              account: _vm.getUser.userAccount,
            },
          })
        : _vm._e(),
      _vm.videoListShow
        ? _c("short-videos", { attrs: { onCancel: _vm.toogleVideoShow } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }